import { LegendWithOneLineBulletFlex } from "@similarweb/ui-components";
import { Stack } from "@similarweb/ui-components/foundations";

interface ILegendItem {
    name: string;
    value: string;
    color: string;
}

interface ILegendProps {
    items: ILegendItem[];
    dataAutomation?: string;
}

export const Legend = ({ items, dataAutomation }: ILegendProps) => {
    return (
        <Stack
            gap="8px"
            flex="1"
            data-automation={dataAutomation}
        >
            {items.map((item) => (
                <LegendWithOneLineBulletFlex
                    key={item.name}
                    text={item.name}
                    value={item.value}
                    labelColor={item.color}
                />
            ))}
        </Stack>
    );
};
